import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'core_collections-product_based_collection_tile-view';

/**
 * View all collections impression
 */
export function trackCoreCollectionsProductBasedCollectionTileView(
  productBasedCollectionToken: string,
  customParameterToken: string,
  brandPromoCollectionToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      productBasedCollectionToken,
      customParameterToken,
      brandPromoCollectionToken,
    },
  });
}
